export const GET_GALLERY_DATA = "GET_GALLERY_DATA";
export const GET_NFT_DETAILS = "GET_NFT_DETAILS";
export const GET_APPELATION_DATA = "GET_APPELATION_DATA";
export const GET_BRAND_DATA = "GET_BRAND_DATA";
export const GET_FILTER_DATA = "GET_FILTER_DATA";
export const GET_FEATURE_DATA='GET_FEATURE_DATA';
export const GET_PROVIDER_DATA='GET_PROVIDER_DATA';
export const GET_COLLECTION_DATA='GET_COLLECTION_DATA';
export const GET_GRAPE_VARIETY_DATA='GET_GRAPE_VARIETY_DATA';
